import { Button, Col, Input, Row, Form, Checkbox, Select, DatePicker, notification, Spin } from "antd";
import { useState } from "react";
import { useEffect } from "react";
import { addClientApi, listOfClientApi, listOfProgramApi, listOfUsersApi } from "../../../config/Api";
import { API_DATE_FORMAT, API_ERR_MESSAGE, DATE_FORMAT, EMAIL_PATTERN, PASSWORD_RULES, PHONE_PATTERN, PHONE_PATTERN_MESSAGE } from "../../../config/constant";
import { FilterApiData } from "../../../services/FilterApiData";
import "./style/AddPatient.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export const AddPatient = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const navigate = useNavigate();
    const [selectedProgram, setSelectedProgram] = useState('')
    const [loading, setLoading] = useState(false)
    const [selectedProgramData, setselectedProgramData] = useState()
    const [nutritionistType, setNutritionistType] = useState('');

    const [programOptionsList, setProgramOptionsList] = useState([])
    const [usersList, setUsersList] = useState([])


    const [activePatientList, setActivePatientList] = useState([])
    const [patientList, setPatientList] = useState([])
    const [totalActiveClientLimit, setTotalActiveClientLimit] = useState(0)

    // get the list of all complaints
    const getlistProgram = () => {
        listOfProgramApi()
            .then((res) => {
                if (res.status === 200) {
                    // setProgramOptionsList(res.data.data);
                    setProgramOptionsList(FilterApiData(res.data.data))
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }


    useEffect(() => {
        if (selectedProgram) {
            updateProgram(selectedProgram)
        }
    }, [selectedProgram])

    // when user select start date then add no of days available in selected program duration that is end date 
    //==============================
    const findProgramEndDate = (startDate) => {
        // console.log('startDate', startDate);
        if (startDate != null) {
            let endDate = moment(startDate, API_DATE_FORMAT).add(parseInt(selectedProgramData?.duration), 'd');
            // console.log('endDate', endDate);
            form.setFieldValue('expiresOn', moment(endDate, API_DATE_FORMAT))
        }
    }

    // get the selected program record data from its selected program
    //==============================
    const updateProgram = (selectdProgramOption) => {

        if (programOptionsList) {

            let programRecord = programOptionsList.find((option) => option.id == selectdProgramOption)
            // console.log(programRecord);
            setselectedProgramData(programRecord);
            // if start date is available and program is change then update end date based om program duration days  
            // if (form.getFieldValue('start_date_of_plan')) {
            //     findProgramEndDate(form.getFieldValue('start_date_of_plan'))
            // }
        }
    }

    // const onFinish = async (values) => {
    //     // console.log("values", values);
    //     let data;
    //     console.log("patientList", patientList, activePatientList, totalActiveClientLimit);
    //     console.log("patientList 1", activePatientList >= totalActiveClientLimit);
    //     // if (FilterApiData(patientList).length >= totalActiveClientLimit) {
    //     if (activePatientList && activePatientList?.length >= totalActiveClientLimit) {
    //         // console.log("limit exceed");
    //         data = {
    //             "name": values.name,
    //             "email": values.email,
    //             "password": values?.password ? values?.password : '',
    //             "mobile": values.mobile,
    //             "whatsapp_number": values.whatsapp_number,
    //             "program_id": values.program,
    //             "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
    //             "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
    //             "status": false,
    //             // when login nutritionist is not ayurvedic doctor the value does not come so pass false
    //             "phenotype_status": values?.phenoType ? values?.phenoType : false,
    //             "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
    //         }
    //     } else {
    //         data = {
    //             "name": values.name,
    //             "email": values.email,
    //             "password": values?.password ? values?.password : '',
    //             "mobile": values.mobile,
    //             "whatsapp_number": values.whatsapp_number,
    //             "program_id": values.program,
    //             "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
    //             "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
    //             "status": true,
    //             // when login nutritionist is not ayurvedic doctor the value does not come so pass false
    //             "phenotype_status": values?.phenoType ? values?.phenoType : false,
    //             "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
    //         }
    //     }
    //     console.log("patient data", data);
    //     // const data = {
    //     //     "name": values.name,
    //     //     "email": values.email,
    //     //     "password": values?.password ? values?.password : '',
    //     //     "mobile": values.mobile,
    //     //     "whatsapp_number": values.whatsapp_number,
    //     //     "program_id": values.program,
    //     //     "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
    //     //     "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
    //     //     "status": false,
    //     //     // when login nutritionist is not ayurvedic doctor the value does not come so pass false
    //     //     "phenotype_status": values?.phenoType ? values?.phenoType : false,
    //     //     "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
    //     // }


    //     await addClientApi(data)
    //         .then((res) => {
    //             if (res.status == 200) {
    //                 notification.success({
    //                     message: "Patient Detail added successfully",
    //                 });
    //                 form.resetFields()
    //                 console.log("res.data", res?.data);
    //                 // rediect on medicine detail page 
    //                 // ===============
    //                 if (data?.status) {
    //                     localStorage.setItem('activeTabKey', '2')
    //                     navigate(`/patient-detail/${res?.data?.data?.user?.id}`)
    //                 }
    //             }
    //         })
    //         .catch((err) => {
    //             notification.error({
    //                 message: API_ERR_MESSAGE,
    //             });
    //         });
    // };

    const onFinish = async (values) => {
        let data;
        // console.log("patientList", patientList, activePatientList, totalActiveClientLimit);
        // console.log("patientList 1", activePatientList >= totalActiveClientLimit);
        // if total active client limit is less than Plan Active client limit then add patient with active status
        // =================================
        if (activePatientList && activePatientList.length >= totalActiveClientLimit) {
            data = {
                "name": values.name,
                "email": values.email,
                "password": values?.password ? values?.password : '',
                "mobile": values.mobile,
                "whatsapp_number": values.whatsapp_number,
                "program_id": values.program,
                "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
                "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
                "status": false,
                "phenotype_status": values?.phenoType ? values?.phenoType : false,
                "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
            };
        } else {
            data = {
                "name": values.name,
                "email": values.email,
                "password": values?.password ? values?.password : '',
                "mobile": values.mobile,
                "whatsapp_number": values.whatsapp_number,
                "program_id": values.program,
                "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
                "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
                "status": true,
                "phenotype_status": values?.phenoType ? values?.phenoType : false,
                "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
            };
        }
        // console.log("patient data", data);

        try {
            const res = await addClientApi(data);
            if (res.status === 200) {
                notification.success({
                    message: res.data.message || "Patient Detail added successfully",
                });
                form.resetFields();
                // console.log("res.data", res?.data);
                if (data.status) {
                    localStorage.setItem('activeTabKey', '2');
                    navigate(`/patient-detail/${res?.data?.data?.user?.id}`);
                }
            }
        } catch (err) {
            notification.error({
                message: API_ERR_MESSAGE,
            });
        }
    };

    const resetData = () => {
        form.resetFields()
    };
    // console.log("props?.buttonName", props?.buttonName);

    // const getListOfUsers = () => {
    //     listOfUsersApi()
    //         .then((res) => {
    //             if (res.status === 200) {
    //                 setUsersList(res.data.data);
    //             }
    //         })
    //         .catch((err) => {
    //             notification.error({
    //                 message: 'something went wrong',
    //             });
    //         });
    // }
    useEffect(() => {
        getlistProgram()
        // getListOfUsers()
        // when nutritionist add new program display in dropdown without refresh page
    }, [props.programUpdate]);

    useEffect(() => {
        let NutritionistType = JSON.parse(localStorage.getItem('user'))
        // setNutritionistType(NutritionistType?.type_of_account)
        setNutritionistType(NutritionistType?.user?.type_of_account)
        getListOfPatient()
        getListOfUsers()
    }, [])

    // get List of Patient List
    //==============================
    const getListOfPatient = () => {
        setLoading(true)

        listOfClientApi()
            .then((res) => {
                if (res.status === 200) {
                    // set data of those users whose status is ACTIVE
                    if (res?.data?.data) {
                        if (res?.data?.data?.length > 0) {
                            setActivePatientList(FilterApiData(res.data.data));
                            setPatientList(res.data.data);
                            // console.log(FilterApiData(res.data.data).length);
                        }
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                // console.log("err--", err);
                setLoading(false)
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all nutritionist data to get user plan and active client limit
    //=================================
    const getListOfUsers = () => {
        setLoading(true)

        listOfUsersApi()
            .then((res) => {
                if (res.status === 200) {
                    const nutritionistData = FilterApiData(res.data.data);
                    if (nutritionistData.length > 0) {
                        let userId = localStorage.getItem('id')
                        // get the login user data by its userid
                        const loginUserData = nutritionistData.find((element) => element.id == userId);
                        // console.log("total patient limit of user plan", loginUserData?.plan?.active_clients);
                        setTotalActiveClientLimit(loginUserData?.plan?.active_clients)
                    }
                }
                setLoading(false)

            })
            .catch((err) => {
                setLoading(false)

                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }
    return (
        <div className="AddPatient">
            <Spin spinning={loading}>
                <Form
                    name="UpdateClientDetail"
                    className="UpdateClientDetail"
                    form={form}
                    onFinish={onFinish}
                >
                    <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3" >
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>
                            <label className="form-input-label">
                                Name
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Enter Name!",
                                    },
                                ]}
                            // initialValue={name}
                            >
                                <Input placeholder="Enter Name" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>
                            <label className="form-input-label">
                                Email
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="email"
                                rules={[
                                    // { required: props?.buttonName == "Add" ? true : false, message: "Please insert Email!" },
                                    { required: true, message: "Please insert Email!" },
                                    {
                                        pattern: EMAIL_PATTERN,
                                        message: "Please insert valid data!",
                                    },
                                ]}
                            >
                                {/* <Input placeholder="Enter Email ID" disabled={props?.buttonName == "UPDATE" ? true : false} className="mt-2 p-2" /> */}
                                <Input placeholder="Enter Email ID"
                                    // disabled={props?.buttonName == "UPDATE" ? true : false}
                                    className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Phone
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="mobile"
                                // initialValue={mobile}
                                rules={[
                                    { required: true, message: "Please insert Mobile No!" },
                                    {
                                        pattern: PHONE_PATTERN,
                                        message: "Please insert valid data!",
                                    },
                                ]}
                            >
                                <Input maxLength={10} placeholder="Enter Phone No" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>
                            <label className="form-input-label">
                                Password
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="password"
                                validateFirst
                                rules={[{ required: false, message: "Please insert password!" }, ...PASSWORD_RULES]}
                            >
                                <Input.Password placeholder="Enter Password" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Program
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="program"
                                // initialValue={program}
                                rules={[{ required: true, message: "Please Select Program!" }]}
                                initialValue=""
                            >

                                <Select
                                    className="w-100 mt-2"
                                    // value={regType}
                                    // defaultValue=""
                                    onChange={(e) => { setSelectedProgram(e); updateProgram(e) }}

                                >
                                    <Option value="" disabled hidden>
                                        Select Program
                                    </Option>
                                    {
                                        programOptionsList && programOptionsList.length > 0 && programOptionsList.map((option, index) =>
                                            <Option key={index} value={option.id}>{option.name}</Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Select Nutritionist
                        </label>
                        <Form.Item
                            name="select_nutritionist"
                        // initialValue={nutritionist}
                        // rules={[{ required: true, message: "Please insert Price!" }]}
                        >
                            <Select
                                className="mt-2"
                                // value={regType}
                                defaultValue=""
                            // onChange={(e) => setRegType(e)}
                            >
                                <Option value="" disabled hidden>
                                    Select Nutritionist
                                </Option>
                                <Option value="Krunal Patadiya">Krunal Patadiya</Option>
                                <Option value="Prakash Gujarati">Prakash Gujarati</Option>
                                <Option value="Mansi Bhojani">Mansi Bhojani</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Plan Start Date
                                <span className="asterik"> *</span>
                            </label>
                            <Form.Item
                                name="start_date_of_plan"
                                rules={[{ required: true, message: "Please Select Start Date!" }]}
                            >
                                <DatePicker
                                    // key={`${startDate}`}
                                    // defaultValue={
                                    //     startDate !== ""
                                    //         ? moment(startDate)
                                    //         : undefined
                                    // }
                                    // onChange={(value: any, dateString: any) => setEntryDate(dateString)}
                                    format={API_DATE_FORMAT}
                                    // disabled={selectedProgram && form.getFieldValue('start_date_of_plan') ? false : true}
                                    className="w-100 mt-2 p-2"
                                // onChange={(e) => findProgramEndDate(e)}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Plan End Date
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="expiresOn"
                                rules={[{ required: false, message: "Please Select End Date!" }]}
                            >
                                <DatePicker
                                    // key={`${expiresOn}`}
                                    // defaultValue={
                                    //     expiresOn !== ""
                                    //         ? moment(expiresOn)
                                    //         : undefined
                                    // }
                                    // onChange={(value: any, dateString: any) => setEntryDate(dateString)}
                                    format={API_DATE_FORMAT}
                                    className="w-100 mt-2 p-2"

                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Whatspp Number
                                {/* <span className="asterik"> *</span> */}
                            </label>
                            <Form.Item
                                name="whatsapp_number"
                                // initialValue={whatsappNo}
                                rules={[
                                    { required: true, message: "Please insert WhatsApp No!" },
                                    {
                                        pattern: PHONE_PATTERN,
                                        message: "Please insert valid data!",
                                    },
                                ]}
                            >
                                <Input maxLength={10} placeholder="Enter Whatspp No" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>

                        {
                            // nutritionistType !== 'Nutritionist (Ayurveda)' &&
                            nutritionistType == 'Nutritionist (Ayurveda)' &&
                            <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>
                                <span
                                    style={{
                                        display:
                                            nutritionistType !== 'Nutritionist (Ayurveda)' && 'none'
                                    }}
                                >
                                    <label className="form-input-label">
                                        Phenotype
                                    </label>
                                    <Form.Item
                                        name="phenoType"
                                        rules={[{ required: false, message: "Please select PhenoType!" }]}
                                        initialValue="false"
                                    >
                                        <Select
                                            className="mt-2"
                                        // value={regType}
                                        // defaultValue={phenoType ? phenoType : ""}
                                        // onChange={(e) => setRegType(e)}
                                        >
                                            <Option value="" disabled hidden>
                                                Select Phenotype
                                            </Option>
                                            <Option value="true">Enable</Option>
                                            <Option value="false">Disable</Option>
                                        </Select>
                                    </Form.Item>
                                </span>
                            </Col>
                        }
                        <Col xs={24} sm={12} md={11} lg={11} xl={11} xxl={12}>

                            <label className="form-input-label">
                                Reason For Contact
                            </label>
                            <Form.Item
                                name="reasonForContact"
                                rules={[
                                    { required: false, message: "Please insert Reason For Contact!" },
                                ]}
                            >
                                <Input.TextArea placeholder="Enter Reason For Contact" className="mt-2 p-2" />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={11} lg={11} xl={12} xxl={12} className="text-end align-items-center align-self-center">
                            <Button htmlType="submit" className="submit-button b-0 rounded">
                                SAVE
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </div >
    )
}
